// scrollManager.js
import { writable, get } from 'svelte/store';
import {tick} from "svelte";

export const scrollPositions = writable({});
export const navigatedBack = writable(false);

let currentPage = '';

// Function to restore scroll position
async function restoreScrollPosition() {
    await tick();
    let positiongs = get(scrollPositions);
    for(let i in positiongs) {
        if (i === currentPage) {
            setTimeout(() => {
                window.scrollTo({top: positiongs[i], left: 0, behavior: 'instant'});
            }, 100);
        }
    };
}

// Listen to popstate event for back navigation
window.addEventListener('popstate', () => {
    navigatedBack.set(true);
});

// Set the current page
export function setCurrentPage(page) {
    currentPage = page;
}

// Save scroll position
export function saveScrollPosition() {
    scrollPositions.update(positions => ({
        ...positions,
        [currentPage]: window.scrollY
    }));
}

// Call this function once in your main component to handle back navigation
export function handleBackNavigation() {
    navigatedBack.subscribe(value => {
        if (value) {
            restoreScrollPosition();
            navigatedBack.set(false); // Reset the flag
        }
    });
}
